import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import "../css/TermInsuranceForm.css";
import { submitTermInsuranceFormData,getAgentIdByToken } from "../services/api";
import translations from './TermInsuranceFormTranslations'; // Import translations

const TermInsuranceForm = () => {
  const { token } = useParams();
  const [formData, setFormData] = useState({
    form_timestamp: new Date().toISOString().slice(0, 19).replace('T', ' '),
    //form_timestamp: new Date().toLocaleString(),
    email: '',
    form_language: 'en', // Default to English
    name: '',
    mobile: '',
    city_of_residence: '',
    otherCity: '', // Add this line
    dob:'',
    age: '',
    desired_retirement_age: '',
    gender: '',
    marital_status: '',
    sole_earning_member:'',
    spouse_age: '',
    expected_life_expectancy_spouse: '',
    number_of_dependents: '0',
    current_annual_income: '',
    current_monthly_household_expenses: '',
    existing_term_insurance_coverage: '',
    outstanding_lt_liabilities: '', // Q7
    insurance_for_liabilities: '', // Q8
    amount_of_cover_taken: '', // Q9
    est_funds_for_lt_responsibilities: '',
    investments_for_responsibilities: '',
    pf_balance: '',
    other_investments_ppf_nps: '',
    agent_id: '',
  });
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [errors, setErrors] = useState({});
  const [dobConstraints, setDobConstraints] = useState({ min: '', max: '' });
  const [ageError, setAgeError] = useState('');
  const [loadingAgent, setLoadingAgent] = useState(true);
  const [agentError, setAgentError] = useState('');
  // Retrieve agentId from localStorage (if available)
     const [agentId, setAgentId] = useState({});
   
// Fetch agent ID from backend using token in URL
    useEffect(() => {
        const fetchAgentId = async () => {
            try {
                // Extract token from URL path
                const pathParts = window.location.pathname.split('/');
                const token = pathParts[pathParts.length - 1];
                console.log("normal token child education111:");
                console.log("token: child education222", token);

                
                if (token) {
                    const response = await getAgentIdByToken(token);
                    console.log("==response child education==",response.data)
                          
                    setAgentId(response.data);

                      // Update formData with agent_id
                    setFormData(prev => ({ ...prev, agent_id: response.data }));
                } else {
                    // Fallback to localStorage if token not found
                    const storedAgentId = localStorage.getItem("agentId");

                    if (storedAgentId) {
                      const id = parseInt(storedAgentId, 10);
                      setAgentId(id);
                      setFormData(prev => ({ ...prev, agent_id: id }));

                    } else {
                        setAgentError("Agent information could not be loaded");
                    }
                }
            } catch (error) {
              console.error('Error fetching agent ID:', error);
              setAgentError("Failed to load agent information");
              const storedAgentId = localStorage.getItem("agentId");
              if (storedAgentId) {
                const id = parseInt(storedAgentId, 10);
                setAgentId(id);
                setFormData(prev => ({ ...prev, agent_id: id }))
            } 
          }
          finally {
                setLoadingAgent(false);
            }
        };

        fetchAgentId();
    }, []);

  useEffect(() => {
    if (formData.marital_status !== 'Married') {
      setFormData((prev) => ({
        ...prev,
        spouse_age: 0,
        expected_life_expectancy_spouse: 0,
      }));
    }
  }, [formData.marital_status]);
  
  useEffect(() => {
    const today = new Date();
    const maxDOB = new Date(today.getFullYear() - 23, today.getMonth(), today.getDate());
    const minDOB = new Date(today.getFullYear() - 50, today.getMonth(), today.getDate());
    setDobConstraints({
      max: maxDOB.toISOString().split("T")[0],
      min: minDOB.toISOString().split("T")[0],
    });
  }, []);
  
  useEffect(() => {
    console.log("📦 Token received in TermInsuranceForm:", token);
  }, [token]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
  
    if (name === 'dob') {
      const dobDate = new Date(value);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const m = today.getMonth() - dobDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
        age--;
      }
  
      setFormData(prev => ({
        ...prev,
        dob: value,
        age: age,
      }));
  
      if (age < 23 || age > 50) {
        setAgeError("Age must be between 23 and 50 years.");
      } else {
        setAgeError('');
      }
  
      setErrors(prevErrors => ({ ...prevErrors, dob: '' }));
      return;
    }
  
    // Enforce positive numbers only for certain fields
    const positiveNumberFields = [
      'mobile',
      'spouse_age',
      'expected_life_expectancy_spouse',
      'current_annual_income',
      'current_monthly_household_expenses',
      'existing_term_insurance_coverage'
    ];
  
    if (positiveNumberFields.includes(name)) {
      const numericValue = Number(value);
      if (numericValue < 0) {
        alert("Please enter a positive value (0 or above).");
        setFormData(prev => ({
          ...prev,
          [name]: ''
        }));
        return;
      }
    }
  
    setFormData(prev => ({
      ...prev,
      [name]: type === 'number' ? parseInt(value) : value
    }));
    if (name === 'city_of_residence') {
      setFormData(prev => ({
       ...prev,
       city_of_residence: value,
       // Clear otherCity when a predefined city is selected
       ...(value !== 'Others' && { otherCity: '' }),
      }));
     } 
    if (name === 'otherCity') {
      setFormData(prev => ({ ...prev, otherCity: value }));
      }
    if (name === 'form_language') {
      setCurrentLanguage(value);
      setErrors({});
    } else {
      setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    }
    
  };
    
  useEffect(() => {
    const liabilitiesAmount = Number(formData.outstanding_lt_liabilities);
    const insuranceCover = formData.insurance_for_liabilities;

    if (liabilitiesAmount === 0) {
      setFormData(prev => ({
        ...prev,
        insurance_for_liabilities: 'notApplicable',
        amount_of_cover_taken: '0',
      }));
    } else {
      if (formData.insurance_for_liabilities === 'notApplicable') {
        setFormData(prev => ({ ...prev, insurance_for_liabilities: '' }));
      }
      if (insuranceCover === 'No') {
        setFormData(prev => ({ ...prev, amount_of_cover_taken: '0' }));
      } else if (insuranceCover === 'Yes' || insuranceCover === 'Partial') {
        // Allow editing of amount_of_cover_taken
      } else {
        setFormData(prev => ({ ...prev, amount_of_cover_taken: '' }));
      }
    }
  }, [formData.outstanding_lt_liabilities, formData.insurance_for_liabilities]);

  const validateForm = () => {
    const lang = currentLanguage;
    const err = {};
    if (!formData.city_of_residence) {
      err.city_of_residence = e('requiredCity') || "Please select your city of residence.";
     } else if (formData.city_of_residence === 'Others' && !formData.otherCity.trim()) {
      err.otherCity = e('requiredOtherCity') || "Please specify your city.";
     }
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      err.email = e('invalidEmail') || "Please enter a valid email address.";
    }

    // Validate mobile number
    const mobileRegex = /^(?!.*(\d)\1\1\1)[6-9]\d{9}$/;
    if (!mobileRegex.test(formData.mobile)) {
      err.mobile = e('invalidMobile') || "Please enter a valid 10-digit mobile number starting with 6-9 without 4 identical digits consecutively.";
    }

    // Validate spouse details if Married
    if (formData.marital_status === "Married") {
      if (isNaN(formData.spouse_age) || formData.spouse_age < 20 || formData.spouse_age > 55) {
        err.spouse_age = e('invalidSpouseAge') || "Spouse age must be between 20 and 55.";
      }
      if (isNaN(formData.expected_life_expectancy_spouse) || formData.expected_life_expectancy_spouse < 60 || formData.expected_life_expectancy_spouse > 90) {
        err.expected_life_expectancy_spouse = e('invalidSpouseLifeExpectancy') || "Spouse life expectancy must be between 60 and 90.";
      }
    }

    // Validate Annual Income (min 500000)
    if (isNaN(formData.current_annual_income) || formData.current_annual_income < 500000) {
      err.current_annual_income = e('invalidAnnualIncome') || "Annual income must be at least 500000.";
    }

    // Validate Monthly Expenses (min 10000 and annualized <= annual income)
    if (isNaN(formData.current_monthly_household_expenses) || formData.current_monthly_household_expenses < 10000) {
      err.current_monthly_household_expenses = e('invalidMonthlyExpensesMin') || "Monthly household expenses must be at least 10000.";
    }
    if ((formData.current_monthly_household_expenses * 12) > formData.current_annual_income) {
      err.current_monthly_household_expenses = e('invalidMonthlyExpensesMax') || "Annualized household expenses cannot exceed annual income.";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.city_of_residence === 'Others') {
      FormData.city_of_residence = formData.otherCity.trim();
     }
    if (validateForm()) {
      console.log("Submitting form:", formData);
      try {
        console.log("Right before you call your API, add:", formData);
        const response = await submitTermInsuranceFormData(formData, token);
        console.log("responsem:", response.data);

        const currentTranslations = translations[currentLanguage] || translations['en'] || {};
        if (response.status === 200) {
          alert(currentTranslations.alerts?.submitSuccess || "Form submitted successfully!");
        } else {
          alert(currentTranslations.alerts?.submitFailure || "Form submission failed. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        const currentTranslations = translations[currentLanguage] || translations['en'] || {};
        alert(currentTranslations.alerts?.submitError || "Something went wrong. Please try again later.");
      }
    } else {
      alert(e('formErrors') || "Please correct the errors in the form.");
    }
  };

  const t = (key) => {
    return translations?.[currentLanguage]?.labels?.[key] || translations?.en?.labels?.[key] || key;
  };

  const p = (key) => {
    return translations?.[currentLanguage]?.placeholders?.[key] || translations?.en?.placeholders?.[key] || '';
  };

  const o = (key) => {
    return translations?.[currentLanguage]?.data?.[key] || translations?.en?.data?.[key] || [];
  };

  const e = (key) => {
    return translations?.[currentLanguage]?.errors?.[key] || translations?.en?.errors?.[key] || key;
  };

  return (
    <div className="term-insurance-form-container">
      <div className="term-insurance-form">
        <h1>{t('title')}</h1>
        <p style={{ color: 'rgb(112, 16, 99)' }}>
          {t('description')}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('form_timestamp')}</label>
            <input
              type="text"
              name="form_timestamp"
              value={formData.form_timestamp}
              readOnly
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{t('email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={p('email')}
              required
            />
            {errors.email && <p className="error-message">{errors.email}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="form_language">{t('form_language')}</label>
            <select id="form_language" name="form_language" value={formData.form_language} onChange={handleChange} required>
              <option value="en">English</option>
              <option value="hi">हिन्दी</option>
            </select>
          </div>

          <div className="form-group">
            <label>{t('name')}</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder={p('name')} />
            {errors.name && <p className="error-message">{errors.name}</p>}
          </div>

          <div className="form-group">
            <label>{t('mobile')}</label>
            <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} 
                placeholder={p('mobile')} 
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
            />
            {errors.mobile && <p className="error-message">{errors.mobile}</p>}
          </div>
          <div className="form-group">
            <label>{t('gender')} <span className="required-indicator">*</span></label>
            <div className="option-pills">
              {o('genderOptions').map(option => (
                <label key={option.value} className="pill">
                  <input
                    type="radio"
                    name="gender"
                    value={option.value}
                    checked={formData.gender === option.value}
                    onChange={handleChange}
                  />
                  <span>{option.label}</span>
                </label>
              ))}
            </div>
            {errors.gender && <p className="error-message">{errors.gender}</p>}
          </div>
          <div className="form-group">
                  <label htmlFor="dob">{t('dob') || "Date of Birth"}</label>
                  <input
                    type="date"
                    id="dob"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    min={dobConstraints.min}
                    max={dobConstraints.max}
                    required
                  />
          </div>
          <div className="form-group">
                <label htmlFor="age">{t('age')}</label>
                <input
                  type="text"
                  id="age"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  readOnly
                  placeholder={p('age') || 'Enter your age'}
                  pattern="[0-9]*" // This pattern allows only digits
                  inputMode="numeric" // Helps mobile keyboards show numeric keypad
                />
                {ageError && <p className="error-message">{ageError}</p>}
            </div>
            <div className="form-group">
                <label htmlFor="city_of_residence">{t('city_of_residence')}:</label>
                <select
                  id="city_of_residence"
                  name="city_of_residence"
                  value={formData.city_of_residence}
                  onChange={handleChange}
                >
                  <option value="">{t('city_of_residence_select') || '-- Select City --'}</option>
                  {currentLanguage === 'hi' 
                    ? o('cityOptions').map(city => (
                        <option key={city.value} value={city.value}>
                          {city.label}
                        </option>
                      ))
                    : o('cityOptions').map(city => (
                        <option key={city.value} value={city.value}>
                          {city.value}
                        </option>
                      ))
                  }
                </select>
                  {errors.city_of_residence && <p className="error-message">{errors.city_of_residence}</p>}
                </div>
          {formData.city_of_residence === 'Others' && (
              <div className="form-group">
                    <label htmlFor="otherCity">{t('otherCity')}</label>
                    <input
                    type="text"
                    id="otherCity"
                    name="otherCity"
                    value={formData.otherCity}
                    onChange={handleChange}
                    placeholder={p('otherCity')}
                    required={formData.city_of_residence === 'Others'}
                    />
                    {errors.otherCity && <p className="error-message">{errors.otherCity}</p>}
                </div>
            )}
          <div className="form-group">
            <label htmlFor="number_of_dependents">{t('number_of_dependents')}</label>
            <select
              id="number_of_dependents"
              name="number_of_dependents"
              value={formData.number_of_dependents}
              onChange={handleChange}
              placeholder={p('dependents')}

            >
              {o('dependentsOptions').map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
            {errors.number_of_dependents && <p className="error-message">{errors.number_of_dependents}</p>}
          </div>
          <div className="form-group">
	            <label>
	              {t('sole_earning_member')} <span className="required-indicator">*</span>
	            </label>
	            <div className="option-pills">
	              {o('soleEarnerOptions').map(option => (
	                <label key={option.value} className="pill">
	                  <input
	                    type="radio"
	                    name="sole_earning_member"
	                    value={option.value}
	                    checked={formData.sole_earning_member === option.value}
	                    onChange={handleChange}
	                  />
	                  <span>{option.label}</span>
	                </label>
	              ))}
	            </div>
				{errors.sole_earning_member && (
                <p className="error-message">{errors.sole_earning_member}</p>
              )}
	          </div>
        

          <div className="form-group">
            <label htmlFor="desired_retirement_age">6. {t('desired_retirement_age')}</label>
            <input
              type="text"
              id="desired_retirement_age"
              name="desired_retirement_age"
              pattern="[0-9]*" // This pattern allows only digits
              inputMode="numeric" // Helps mobile keyboards show numeric keypad
              value={formData.desired_retirement_age}
              onChange={handleChange}
            />
            {errors.desired_retirement_age && <p className="error-message">{errors.desired_retirement_age}</p>}
          </div>


          <div className="form-group">
            <label>{t('marital_status')} <span className="required-indicator">*</span></label>
            <div className="option-pills">
              {o('maritalStatusOptions').map(option => (
                <label key={option.value} className="pill">
                  <input
                    type="radio"
                    name="marital_status"
                    value={option.value}
                    checked={formData.marital_status === option.value}
                    onChange={handleChange}
                  />
                  <span>{option.label}</span>
                </label>
              ))}
            </div>
            {errors.marital_status && <p className="error-message">{errors.marital_status}</p>}
          </div>

          <div className="form-group">
              <label htmlFor="spouse_age">{t('spouse_age')}</label>
              <input  type="text"
                id="spouse_age"
                name="spouse_age"
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
                value={formData.spouse_age}
                onChange={handleChange}
                disabled={formData.marital_status !== 'Married'}
                placeholder={p('spouse_age')}
              />
              {errors.spouse_age && <p className="error-message">{errors.spouse_age}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="expected_life_expectancy_spouse">{t('expected_life_expectancy_spouse')}</label>
            <input
              type="text"
              id="expected_life_expectancy_spouse"
              name="expected_life_expectancy_spouse"
              pattern="[0-9]*" // This pattern allows only digits
              inputMode="numeric" // Helps mobile keyboards show numeric keypad
              value={formData.expected_life_expectancy_spouse}
              onChange={handleChange}
              disabled={formData.marital_status !== 'Married'}
              placeholder={p('expected_life_expectancy_spouse')}
            />
            {errors.expected_life_expectancy_spouse && <p className="error-message">{errors.expected_life_expectancy_spouse}</p>}
          </div>

          
          <div className="form-group">
            <label htmlFor="annualIncome">{t('current_annual_income')} (required)</label>
            <input type="text" id="current_annual_income" name="current_annual_income" 
              pattern="[0-9]*" // This pattern allows only digits
              inputMode="numeric" // Helps mobile keyboards show numeric keypad
            value={formData.current_annual_income} onChange={handleChange} />
            {errors.current_annual_income && <p className="error-message">{errors.current_annual_income}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="monthlyExpenses">{t('current_monthly_household_expenses')} (required)</label>
            <input type="text" id="current_monthly_household_expenses" name="current_monthly_household_expenses" 
              pattern="[0-9]*" // This pattern allows only digits
              inputMode="numeric" // Helps mobile keyboards show numeric keypad
            value={formData.current_monthly_household_expenses} onChange={handleChange} />
            {errors.current_monthly_household_expenses && <p className="error-message">{errors.current_monthly_household_expenses}</p>}
          </div>

	          <div className="form-group">
	            <label htmlFor="existing_term_insurance_coverage">
	              {t('existing_term_insurance_coverage')} (required)
	            </label>
	            <select
	              id="existing_term_insurance_coverage"
	              name="existing_term_insurance_coverage"
	              value={formData.existing_term_insurance_coverage}
	              onChange={handleChange}
	            >
	              <option value="">-- {t('select') || '-- Select --'} --</option>
	              {o('termInsuranceCoverageOptions').map(option => (
	                <option key={option} value={option}>{option === 'other' ? t('other') : `₹${parseInt(option).toLocaleString('en-IN')}`}</option>
	              ))}
	            </select>
	          </div>
	
	          <div className="form-group">
	            <label htmlFor="longTermLiabilities">{t('outstanding_lt_liabilities')} (required)</label>
	            <input type="text" id="outstanding_lt_liabilities" name="outstanding_lt_liabilities"
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
               value={formData.outstanding_lt_liabilities} onChange={handleChange} 
               placeholder={p('outstanding_lt_liabilities') || 'Enter total estimated value (Type 0 if none)'}/>

              
	          </div>
	
	          <div className="form-group">
	            <label>
	              {t('insurance_for_liabilities')} <span className="required-indicator">*</span>
	            </label>
	            <div className="option-pills">
	              {o('liabilitiesInsuranceCoverOptions').map(option => (
	                <label key={option.value} className="pill">
	                  <input
	                    type="radio"
	                    name="insurance_for_liabilities"
	                    value={option.value}
	                    checked={formData.insurance_for_liabilities === option.value}
	                    onChange={handleChange}
	                  />
	                  <span>{option.label}</span>
	                </label>
	              ))}
	            </div>
	          </div>
	
	          <div className="form-group">
	            <label htmlFor="liabilityCoverAmount">{t('amount_of_cover_taken')}</label>
	            <input type="text" id="amount_of_cover_taken" name="amount_of_cover_taken" 
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
              value={formData.amount_of_cover_taken} onChange={handleChange} 
              placeholder={p('amount_of_cover_taken') || 'Enter cover amount'}/>

            </div>
	
	          <div className="form-group">
	            <label htmlFor="longTermResponsibilitiesFunds">{t('est_funds_for_lt_responsibilities')}</label>
	            <input type="text" id="est_funds_for_lt_responsibilities" name="est_funds_for_lt_responsibilities" 
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
              value={formData.est_funds_for_lt_responsibilities} onChange={handleChange} 
              placeholder={p('est_funds_for_lt_responsibilities') || 'Enter total estimated funds (Type 0 if none)'}/>
            </div>
	
	          <div className="form-group">
	            <label htmlFor="longTermResponsibilitiesSavings">{t('investments_for_responsibilities')}</label>
	            <input type="text" id="investments_for_responsibilities" name="investments_for_responsibilities" 
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
              value={formData.investments_for_responsibilities} onChange={handleChange} 
               placeholder={p('investments_for_responsibilities') || 'Enter total estimated value (Type 0 if none)'}/>
	          </div>
	
	          <div className="form-group">
	            <label htmlFor="pfBalance">{t('pf_balance')}</label>
	            <input type="text" id="pf_balance" name="pf_balance"
                pattern="[0-9]*" // This pattern allows only digits
                inputMode="numeric" // Helps mobile keyboards show numeric keypad
              value={formData.pf_balance} onChange={handleChange} 
               placeholder={p('pf_balance') || 'Enter PF balance (e.g., 100000)'}
              />
	          </div>
	
            <div className="form-group">
                <label htmlFor="other_investments_ppf_nps">
                  {t('other_investments_ppf_nps')}
                </label>
                <input
                  type="text"
                  id="other_investments_ppf_nps"
                  name="other_investments_ppf_nps"
                  pattern="[0-9]*" // This pattern allows only digits
                  inputMode="numeric" // Helps mobile keyboards show numeric keypad
                  value={formData.other_investments_ppf_nps}
                  onChange={handleChange}
                  placeholder={p('other_investments_ppf_nps') || 'Enter total estimated value (Type 0 if none)'}
                />
            </div>

	

          <button type="submit" className="submit-btn">{t('submit')}</button>
        </form>
      </div>
    </div>
  );
};
export default TermInsuranceForm;